(function(angular){
	'use strict';
	
	angular.module('allocationBreakdownTableModule', [
		'BaseConfig'
	]);

})(window.angular);